import Vue from 'vue'
import ui from "@/assets/scripts/ui";

Vue.filter('statusLabel', function (status) {

    if (status === 1) {
        return 'Ativo'
    } else if (status === 2) {
        return 'Inativo'
    } else if (status === 90) {
        return 'Cancelado'
    }

});


Vue.filter('yesOrNot', function (value) {

    if (value === 1 || value === 'Y' || value) {
        return 'Sim'
    } else {
        return 'Não'
    }

});

Vue.filter('weightKg', function (value) {

    return value.toLocaleString('pt-br') + " Kg"

});

Vue.filter('lpad', function (value, length) {

    /*Permitido informar 0 para formatar por exemplo 0000*/
    if (value !== '' && value !== null && value !== undefined) {
        return value.toString().padStart(length, "0")
    }

});


Vue.filter('commandLabel', function (command) {

    if (command === 'insert') {
        return 'Incluir'
    } else if (command === 'update') {
        return 'Alterar'
    } else if (command === 'delete') {
        return 'Excluir'
    } else if (command === 'read') {
        return 'Visualizar'
    }

});

Vue.filter('money', function (item) {

    if (item !== null && typeof item == 'number') {
        return item.toLocaleString('pt-br', {style: 'currency', currency: 'BRL'})
    }

});

Vue.filter('percent', function (value, decimals = 2) {

    if (value === null || value === undefined || isNaN(value)) {
        return '0,00%'; // Retorno padrão se o valor for inválido
    }



    // Garante que seja um número
    let number = parseFloat(value);

    // Formata o número com o número de casas decimais desejado
    return number.toLocaleString('pt-BR', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    }) + '%';
});

Vue.filter('number', function (item, maximumSignificantDigits = null, minimumFractionDigits = null) {

    if (item !== null) {

        let options = {}
        if (maximumSignificantDigits !== null)
            options.maximumSignificantDigits = maximumSignificantDigits

        if (minimumFractionDigits !== null)
            options.minimumFractionDigits = minimumFractionDigits

        if(options !== {}){
            return item.toLocaleString('pt-br', options)
        }else{
            return item.toLocaleString('pt-br')
        }

    }

});

//Somente data dia mes ano
Vue.filter('date', function (item) {

    if (item !== null && item !== "" && item) {

        //console.log(item)

        if (item.indexOf("T") < 0) {
            item += 'T00:00:00'
        }

        //todo Esta funcionando, porém precisa melhorar
        item = item.replace('T00:00:00', 'T12:00:00')

        return ui.convertDateBR(item)

    }

});

//Somente data dia mes ano + horario
Vue.filter('datetime', function (item) {

    if (item != null && item !== "" && item) {

        if (item.indexOf("T") < 0)
            item += 'T00:00:00'

        return ui.convertDateBR(item, true)

    }

});

//Somente data dia mes ano + horario
Vue.filter('time', function (item) {

    if (item != null && item !== "" && item) {

        const date = new Date(item)
        const convert = date.toLocaleString('pt-br', {timeZone: "UTC"}).split(" ")[1]
        return convert.substring(0, convert.lastIndexOf(":"))

    }

});

Vue.filter('minuteOrHour', function (item) {

    if (item != null) {

        let time = ''

        if (item > 1440) {
            //Exibe apenas a qtd. de dias em aberto
            time = parseInt(item / 1440) + " dias"

        } else if (item > 60) {
            //Exibe a qtd. de horas e minutos
            time = parseInt(item / 60) + "h"
            time += item % 60 + "min"
        } else {
            //Somente minutos
            time = item + "min"
        }

        return time

    }

});

Vue.directive('exemplo-diretiva', {
    // Quando o elemento vinculado é inserido no DOM...
    inserted: function (el) {

        //Não funciona, pois são utilizados objetos vue ao invés de objetos comuns, sendo mais complexa a validação, pois podem ter filhos e assim por diante
        console.log(el)


    }
})





